const presetElements = [
  {
    type: 'time-select',
    element: 'el-time-select'
  },
  {
    type: 'time',
    element: 'el-time-picker'
  },
  {
    type: 'time-picker',
    element: 'el-time-picker'
  }
]

export default presetElements
